<template>
  <div id="cancelRestroModal" class="modal modal-owner">
    <div class="modal-backdrop" />
    <div class="modal-content owner">
      <!--Header-->
      <div class="modal-header">
        <div class="modal-menu flex">
          <div class="modal-title">店舗 解約</div>
          <div class="icon close" @click="error=null" />
        </div>
      </div>
      <div class="modal-body">
        <div class="admin_content">
          <div>店舗を解約します。</div>
          <div class="admin_color-alert">解約後、店舗の情報は削除されます。復旧はできませんのでご注意ください。</div>
          <div>問題ない場合は、「解約する」ボタンを押して続けてください。</div>
          <div class="form-row">
            <span v-if="error" class="error-message">
              {{ error }}
            </span>
          </div>
        </div>
      </div>
      <!--Footer-->
      <div class="modal-footer">
        <button class="btn_admin delete" @click="handleCancel">解約する</button>
      </div>
    </div>
  </div>
</template>
<script>
import {RestaurantAdministratorsService} from '../../../../services/admin/restaurant_administrators.service';

export default {
  props: {
    cancelRestroId: {
      type: Number,
      require: true,
    }
  },
  data() {
    return {
      error: null
    };
  },
  methods: {
    handleCancel: async function () {
      this.$loading(true);
      try {
        await RestaurantAdministratorsService.cancel(this.cancelRestroId);
        this.$emit('refreshTable');
        this.$closeModal('cancelRestroModal');
      } catch (error) {
        this.error = '店舗の解約ができません。';
      }
      this.$loading(false);
    },
  }
};
</script>
<style scoped lang="scss">
#cancelRestroModal{
  .modal-content{
    width: 700px;
    min-width: 700px;
  }
}
</style>